import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useMutation } from '@apollo/client';

import TextBox from '../../text-box/text-box';
import DatepickerBox from '../../datepicker-box/datepicker-box';
import {
  // compareDatesWithTime,
  compareDatesEqualWithoutTime,
  getUserTimeZoneDateFormat,
  compareDatesWithEqualTime,
  isPastDate,
} from '../../../helpers/dateHelper';
import NoData from '../../no-data/no-data';
import {
  CalenderIcon,
  IncidentsNoData,
  MapIcon,
  PlusIcon,
  PrevIcon,
  ShipmentIcon,
  UploadDocumentIcon,
} from '../../icons/icons';
import Button from '../../button/button';
import { giveProfile } from '../../global-notification/notification-list';
import { AddCommentIcon, DownloadZipIcon } from '../../icons/comments-icon';
import ActionButton from '../../actions/actions-btn';
import CommentSection from '../../comment-section/comment-section';
import PanelCard from '../../panel-card/panel-card';
import Dialog from '../../dialog/dialog';
import AdvancePopover from '../../advance-popover/advance-popover';
import store from '../../../redux/store';
import ShipmentProgress from '../shipment-progress';
import AddAddress from '../../add-order-lines/addAddress';
import CustomSwitch from '../../custom-switch/custom-switch';
import SelectForwarder from '../../add-order-lines/selectForwarder';
import PanelCardFooter from '../../panel-card/panel-card-footer';
import UploadDocument from '../../add-order-lines/uploadDocument';
import { fetchAddress } from '../../../helpers/utils';
import {
  getAddress,
  getForwardersAndGeoCodes,
  getNewAddress,
} from './buyerHelper';
import {
  BULK_BUYER_BOOKING,
  CONSOLIDATED_BOOKING,
  RFQ_BOOKING,
  UPDATE_BOOKING,
  UPDATE_SHIPMENT_WITHOUT_FORWARDER,
  UPDATE_CONSOLE_BOOKING,
  CONSOLE_VITRO_BULK_BOOKING,
} from '../../../graphQL/saveBooking';
import useDialog from '../../dialog/useDialog';
import { checkPermission } from '../../../helpers/permissionHelper';
import VendorQuotationSection from './vendorQuotation';
import usePermissionTabs from '../../../helpers/centralized-permissions';
import { BolAWBBLIcon, TrackingLinkIcon } from '../../icons/create-booking';
import AdvanceSelectLabel from '../../advance-select/advance-select-label';
import { WalletIcon } from '../../icons/my-company';

function AddForwarderTab({
  formProps,
  bookingProps,
  switchProps,
  forwarderProps,
  handlerProps,
  miscProps,
  uiProps,
  refetch,
  consigneeId,
  toggleRFQ,
  selectedContract,
  isConsoliatedBooking,
  customIds,
  refetchConsolidatedList,
  toggleViewDetailsModal,
  contractList,
  shipmentProps,
  isVendorPackaging,
  isConsole,
  bulkVitroRefIds,
}) {
  const {
    pickUpDateForm,
    setPickUpDateForm,
    deliveryDateForm,
    setDeliveryDateForm,
    primaryDateForm,
    setPrimaryDateForm,
    scheduledPickupDate,
    setScheduledPickupDate,
    scheduledPickupToDate,
    setScheduledPickupToDate,
  } = formProps;

  const {
    bookingInfo,
    bookingValue,
    matchedBooking,
    deliveryBookingData,
    deliveryBookingCompleted,
    pickUpBookingData,
    pickupBookingCompleted,
    primaryBookingData,
    primaryBookingCompleted,
    deliveryValues,
    pickUpValues,
    prodPackDetails,
    products,
    packages,
  } = bookingProps;

  const {
    pickUpSwitchTo,
    deliverySwitchTo,
    shipmentSwitchTo,
    directShipmentSwitchTo,
    setShipmentSwitchTo,
    setPickUpSwitchTo,
    setDeliverySwitchTo,
    setDirectShipmentSwitchTo,
  } = switchProps;

  const {
    primaryForwarderList,
    pickUpForwarderList,
    deliveryForwarderList,
    setPrimaryForwarderList,
    setPickUpForwarderList,
    setDeliveryForwarderList,
  } = forwarderProps;

  const {
    handleOriginStatus,
    handleDestinationStatus,
    updateSupplierUploadedDocs,
    handleCommentSubmit,
  } = handlerProps;

  const {
    buyerAction,
    selectedVendorType,
    options,
    commentLabel,
    supplierUploadedDocs,
    confirmEntity,
    commentPayload,
    originStatus,
    destinationStatus,
    originValues,
    destinationValues,
    isOriginDoor,
    isDestinationDoor,
    disablePrimaryAtSupplier,
    isActivateUploadDislog,
    toggleUploadDialog,
    update,
    isBulk,
    setOptionValues,
    setDeliveryVal,
    setPickUpVal,
    supplierTab,
    setSupplierTab,
    setAddForworder,
    consolePackageData,
    tableData,
    paymentGateway = '',
    setPaymentGateway = () => {},
    destinationStops = [],
  } = miscProps;

  const {
    isDisabled,
    getClassName,
    isDisabledIcon,
    getIcons,
    setSelectedVendorType,
  } = uiProps;

  const {
    linerData,
    directShipmentEta,
    directShipmentEtd,
    directShipmentBol,
    setLinerData,
    setDirectShipmentEta,
    setDirectShipmentEtd,
    setDirectShipmentBol,
  } = shipmentProps;
  const { relation } = useParams();
  const profileType = giveProfile(relation);
  const getUnit = (pkgUnit) => {
    switch (pkgUnit) {
      case 'metric':
        return 'cm';
      case 'imperial':
        return 'in';
      default:
        return '';
    }
  };
  const [t] = useTranslation('manageorders');
  const [t2] = useTranslation('toast');
  const { isShowing: isActivateCommentDialog, toggle: toggleCommentDialog } =
    useDialog();
  const [searchParams, setSearchParams] = useSearchParams();
  const { toggleDirectShipmentPer } = usePermissionTabs();

  const [primarySelectedFiles, setPrimarySelectedFiles] = useState([]);
  const [pickUpSelectedFiles, setPickUpSelectedFiles] = useState([]);
  const [deliverySelectedFiles, setDeliverySelectedFiles] = useState([]);
  const [disableLastBtn, setDisableLastBtn] = useState(true);
  const [eventValue, setEventValue] = useState();
  const [disableButton, setDisableButton] = useState(false);
  const { channelPartnerData } = useSelector((state) => state.omniDetails);
  const [selectedForwarders, setSelectedForwarders] = useState([]);
  const [primaryAttachment, setPrimaryAttachment] = useState([]);
  const [pickUpAttachment, setPickUpAttachment] = useState([]);
  const [deliveryAttachment, setDeliveryAttachment] = useState([]);
  const [isApiCallPending, setIsApiCallPending] = useState(false);

  const [updateBookingHandler] = useMutation(UPDATE_BOOKING);
  const [updateBulkBookingHandler] = useMutation(BULK_BUYER_BOOKING);
  const [rfqBookingHandler] = useMutation(RFQ_BOOKING);
  const [consolidatedBookingHandler] = useMutation(CONSOLIDATED_BOOKING);
  const [updateBookingWithoutForwarder] = useMutation(
    UPDATE_SHIPMENT_WITHOUT_FORWARDER
  );
  const [updateBookingConsole] = useMutation(UPDATE_CONSOLE_BOOKING);
  const [createConsoleVitroBulkBooking] = useMutation(
    CONSOLE_VITRO_BULK_BOOKING
  );

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }

  const prevScheduledPickUpDateForm = usePrevious(scheduledPickupDate);
  const prevScheduledPickUpDateTo = usePrevious(scheduledPickupToDate);
  const prevPrimaryDateForm = usePrevious(primaryDateForm);
  const prevDeliveryDateForm = usePrevious(deliveryDateForm);
  const prevPickUpDateForm = usePrevious(pickUpDateForm);

  const getLoaderStatus = (e) => {
    setDisableButton(e);
  };
  const togglePopover = (e) => {
    setEventValue(e.target);
  };
  const handleClose = () => {
    setEventValue(null);
  };

  const buildPackagesPayload = (packagesData, lineitemsData) => {
    return packagesData
      ?.filter((pkg) => pkg.selectedProduct && pkg.selectedProduct.length > 0)
      ?.map((pkg) => {
        // map line items
        const lineItems = pkg.selectedProduct
          .map((product) => {
            const lineItem = lineitemsData.find((li) => li._id === product._id);
            if (!lineItem) return null;

            return {
              itemId: lineItem.itemId,
              qtyToShip: Math.abs(lineItem.shippedQty),
              lineGrossWeight: lineItem.grossWeight || 0,
              lineGrossWeightUnit: lineItem.weightUnit || 'Kgs',
              poId: lineItem.orderId,
            };
          })
          .filter(Boolean);

        return {
          packageType: pkg.package?.label || '',
          pkgGrossWt: pkg.grossWeight || '0',
          pkgWtUnit: pkg.measurementUnit || 'metric',
          pkgQty: Number(pkg.quantity) || 1,
          dimentions: {
            length: pkg.length || '0',
            height: pkg.height || '0',
            width: pkg.width || '0',
            dimensionUnit: getUnit(pkg.measurementUnit),
          },
          lineItems,
          isVendor: false,
        };
      });
  };

  const disableLastButton = () => {
    const isTodayOrFuture = (date) => {
      if (!date) return false;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const d = new Date(date);
      d.setHours(0, 0, 0, 0);
      return d < today;
    };

    if (selectedVendorType === 'primary' && primaryDateForm) {
      if (isTodayOrFuture(primaryDateForm)) {
        if (prevPrimaryDateForm !== primaryDateForm) {
          toast.error(t2('buyer.error.notpastdated'));
        }
        setDisableLastBtn(true);
        return true;
      }
    }
    if (isConsole) {
      if (
        (originStatus &&
          pickUpValues?.origin === '' &&
          destinationStatus &&
          deliveryValues?.origin === '') ||
        (originStatus && pickUpValues?.origin === '') ||
        (destinationStatus && deliveryValues?.destination === '')
      ) {
        setDisableLastBtn(true);
        return true;
      }
      if (!scheduledPickupDate || !scheduledPickupToDate) {
        setDisableLastBtn(true);
        return true;
      }
      if (
        scheduledPickupDate &&
        scheduledPickupToDate &&
        compareDatesWithEqualTime(scheduledPickupDate, scheduledPickupToDate)
      ) {
        setDisableLastBtn(true);
        if (
          prevScheduledPickUpDateForm !== scheduledPickupDate ||
          prevScheduledPickUpDateTo !== scheduledPickupToDate
        ) {
          toast.error(t2('buyer.error.scheduledPickupDate'));
        }
        return true;
      }
      if (
        (scheduledPickupDate || scheduledPickupToDate) &&
        isPastDate(scheduledPickupDate, scheduledPickupToDate)
      ) {
        setDisableLastBtn(true);
        if (
          prevScheduledPickUpDateForm !== scheduledPickupDate ||
          prevScheduledPickUpDateTo !== scheduledPickupToDate
        ) {
          toast.error(t2('buyer.error.scheduledPickupDatePast'));
        }
        return true;
      }
    }
    if (directShipmentSwitchTo) {
      if (directShipmentEtd && directShipmentEta) {
        if (compareDatesWithEqualTime(directShipmentEtd, directShipmentEta)) {
          setDisableLastBtn(true);
          toast.error(t2('buyer.error.etaetdDate'));
          return true;
        }
      }
      setDisableLastBtn(false);
      return false;
    }
    /*   if (
        linerData &&
        directShipmentBol &&
        directShipmentEta &&
        directShipmentEtd
      ) {
        setDisableLastBtn(false);
        return false;
      }
      setDisableLastBtn(true);
      return true;
    } */
    if (
      !directShipmentSwitchTo &&
      !shipmentSwitchTo &&
      !isConsole &&
      selectedVendorType === 'primary' &&
      bookingValue?.mode?.value === 'Inland'
    ) {
      if (
        isTodayOrFuture(primaryDateForm) &&
        update &&
        !selectedContract?._id
      ) {
        if (primaryDateForm && prevPrimaryDateForm !== primaryDateForm) {
          toast.error(t2('buyer.error.notpastdated'));
        }
        setDisableLastBtn(true);
      }
      if (
        (scheduledPickupDate || scheduledPickupToDate) &&
        isPastDate(scheduledPickupDate, scheduledPickupToDate)
      ) {
        setDisableLastBtn(true);
        if (
          prevScheduledPickUpDateForm !== scheduledPickupDate ||
          prevScheduledPickUpDateTo !== scheduledPickupToDate
        ) {
          toast.error(t2('buyer.error.scheduledPickupDatePast'));
        }
        return true;
      }
      if (!scheduledPickupDate || !scheduledPickupToDate) {
        setDisableLastBtn(true);
        return true;
      }
      if (
        scheduledPickupDate &&
        scheduledPickupToDate &&
        compareDatesWithEqualTime(scheduledPickupDate, scheduledPickupToDate)
      ) {
        setDisableLastBtn(true);
        if (
          prevScheduledPickUpDateForm !== scheduledPickupDate ||
          prevScheduledPickUpDateTo !== scheduledPickupToDate
        ) {
          toast.error(t2('buyer.error.scheduledPickupDate'));
        }
        return true;
      }

      if (
        primaryForwarderList?.length === 1 &&
        !selectedContract?._id &&
        !isConsole
      ) {
        setDisableLastBtn(true);
        return true;
      }
      setDisableLastBtn(false);
      return false;
    }

    if (
      shipmentSwitchTo &&
      selectedVendorType === 'primary' &&
      bookingValue?.mode?.value === 'Inland'
    ) {
      setDisableLastBtn(false);
      return false;
    }

    if (
      !directShipmentSwitchTo &&
      !isConsole &&
      ((selectedVendorType === 'primary' && buyerAction?.addPrimary) ||
        (selectedVendorType === 'pickUp' && buyerAction?.addPickup) ||
        (selectedVendorType === 'delivery' && buyerAction?.addDelivery))
    ) {
      setDisableLastBtn(true);
      return true;
    }
    if (
      !directShipmentSwitchTo &&
      !isConsole &&
      ((profileType === 'buyer' && !shipmentSwitchTo) ||
        profileType === 'supplier') &&
      selectedVendorType === 'primary'
    ) {
      if (
        isTodayOrFuture(primaryDateForm) &&
        update &&
        !selectedContract?._id
      ) {
        if (primaryDateForm && prevPrimaryDateForm !== primaryDateForm) {
          toast.error(t2('buyer.error.notpastdated'));
        }
        setDisableLastBtn(true);
      }
      if (
        scheduledPickupDate &&
        scheduledPickupToDate &&
        compareDatesWithEqualTime(scheduledPickupDate, scheduledPickupToDate)
      ) {
        setDisableLastBtn(true);
        if (
          prevScheduledPickUpDateForm !== scheduledPickupDate ||
          prevScheduledPickUpDateTo !== scheduledPickupToDate
        ) {
          toast.error(t2('buyer.error.scheduledPickupDate'));
        }
        return true;
      }
      if (
        (scheduledPickupDate || scheduledPickupToDate) &&
        isPastDate(scheduledPickupDate, scheduledPickupToDate)
      ) {
        setDisableLastBtn(true);
        if (
          prevScheduledPickUpDateForm !== scheduledPickupDate ||
          prevScheduledPickUpDateTo !== scheduledPickupToDate
        ) {
          toast.error(t2('buyer.error.scheduledPickupDatePast'));
        }
        return true;
      }
      if (!scheduledPickupDate || !scheduledPickupToDate) {
        setDisableLastBtn(true);
        return true;
      }

      if (primaryForwarderList?.length === 1) {
        setDisableLastBtn(true);
        return true;
      }

      if (
        !directShipmentSwitchTo &&
        !isConsole &&
        ((originStatus &&
          pickUpValues?.origin === '' &&
          destinationStatus &&
          deliveryValues?.origin === '') ||
          (originStatus && pickUpValues?.origin === '') ||
          (destinationStatus && deliveryValues?.destination === ''))
      ) {
        setDisableLastBtn(true);
        return true;
      }

      setDisableLastBtn(false);
      return false;
    }
    if (
      !directShipmentSwitchTo &&
      !isConsole &&
      ((profileType === 'buyer' && !pickUpSwitchTo) ||
        profileType === 'supplier') &&
      selectedVendorType === 'pickUp'
    ) {
      if (!compareDatesEqualWithoutTime(pickUpDateForm, new Date()) && update) {
        if (prevPickUpDateForm !== pickUpDateForm) {
          toast.error(t2('buyer.error.notpastdated'));
        }
        setDisableLastBtn(true);
        return true;
      }
      if (
        scheduledPickupDate &&
        scheduledPickupToDate &&
        compareDatesWithEqualTime(scheduledPickupDate, scheduledPickupToDate)
      ) {
        setDisableLastBtn(true);
        if (
          prevScheduledPickUpDateForm !== scheduledPickupDate ||
          prevScheduledPickUpDateTo !== scheduledPickupToDate
        ) {
          toast.error(t2('buyer.error.scheduledPickupDate'));
        }
        return true;
      }
      if (
        (scheduledPickupDate || scheduledPickupToDate) &&
        isPastDate(scheduledPickupDate, scheduledPickupToDate)
      ) {
        setDisableLastBtn(true);
        if (
          prevScheduledPickUpDateForm !== scheduledPickupDate ||
          prevScheduledPickUpDateTo !== scheduledPickupToDate
        ) {
          toast.error(t2('buyer.error.scheduledPickupDatePast'));
        }
        return true;
      }
      if (!scheduledPickupDate || !scheduledPickupToDate) {
        setDisableLastBtn(true);
        return true;
      }

      if (pickUpForwarderList?.length === 1 || pickUpValues?.origin === '') {
        setDisableLastBtn(true);
        return true;
      }
      setDisableLastBtn(false);
      return false;
    }
    if (
      !directShipmentSwitchTo &&
      !isConsole &&
      ((profileType === 'buyer' && !deliverySwitchTo) ||
        profileType === 'supplier') &&
      selectedVendorType === 'delivery'
    ) {
      if (
        !compareDatesEqualWithoutTime(deliveryDateForm, new Date()) &&
        update
      ) {
        if (prevDeliveryDateForm !== deliveryDateForm) {
          toast.error(t2('buyer.error.notpastdated'));
        }
        setDisableLastBtn(true);
        return true;
      }
      if (!scheduledPickupDate || !scheduledPickupToDate) {
        setDisableLastBtn(true);
        return true;
      }
      if (
        scheduledPickupDate &&
        scheduledPickupToDate &&
        compareDatesWithEqualTime(scheduledPickupDate, scheduledPickupToDate)
      ) {
        setDisableLastBtn(true);
        if (
          prevScheduledPickUpDateForm !== scheduledPickupDate ||
          prevScheduledPickUpDateTo !== scheduledPickupToDate
        ) {
          toast.error(t2('buyer.error.scheduledPickupDate'));
        }
        return true;
      }
      if (
        (scheduledPickupDate || scheduledPickupToDate) &&
        isPastDate(scheduledPickupDate, scheduledPickupToDate)
      ) {
        setDisableLastBtn(true);
        if (
          prevScheduledPickUpDateForm !== scheduledPickupDate ||
          prevScheduledPickUpDateTo !== scheduledPickupToDate
        ) {
          toast.error(t2('buyer.error.scheduledPickupDatePast'));
        }
        return true;
      }
      if (
        !directShipmentSwitchTo &&
        !isConsole &&
        (deliveryForwarderList?.length === 1 ||
          deliveryValues?.destination === '')
      ) {
        setDisableLastBtn(true);
        return true;
      }
      setDisableLastBtn(false);

      return false;
    }

    if (
      profileType === 'buyer' &&
      ((pickUpSwitchTo &&
        selectedVendorType === 'pickUp' &&
        !bookingInfo?.directedBooking?.pickup) ||
        (deliverySwitchTo &&
          selectedVendorType === 'delivery' &&
          !bookingInfo?.directedBooking?.delivery) ||
        (shipmentSwitchTo &&
          selectedVendorType === 'primary' &&
          !bookingInfo?.directedBooking?.primary))
    ) {
      setDisableLastBtn(false);
      return false;
    }
    if (
      !directShipmentSwitchTo &&
      !isConsole &&
      profileType === 'buyer' &&
      ((selectedVendorType === 'pickUp' &&
        bookingInfo?.directedBooking?.pickup) ||
        (selectedVendorType === 'delivery' &&
          bookingInfo?.directedBooking?.delivery) ||
        (selectedVendorType === 'primary' &&
          bookingInfo?.directedBooking?.primary))
    ) {
      setDisableLastBtn(true);
      return true;
    }
    if (
      profileType === 'supplier' &&
      ((selectedVendorType === 'pickUp' && !pickupBookingCompleted) ||
        (selectedVendorType === 'delivery' && !deliveryBookingCompleted) ||
        (selectedVendorType === 'primary' && !primaryBookingCompleted))
    ) {
      setDisableLastBtn(false);
      return false;
    }
    if (
      !directShipmentSwitchTo &&
      !isConsole &&
      profileType === 'supplier' &&
      ((selectedVendorType === 'pickUp' && pickupBookingCompleted) ||
        (selectedVendorType === 'delivery' && deliveryBookingCompleted) ||
        (selectedVendorType === 'primary' && primaryBookingCompleted))
    ) {
      setDisableLastBtn(true);
      return true;
    }

    return false;
  };

  useEffect(() => {
    if (
      isVendorPackaging &&
      !selectedContract?._id &&
      !isConsole &&
      toggleDirectShipmentPer
    ) {
      setDirectShipmentSwitchTo(true);
    } else {
      setDirectShipmentSwitchTo(false);
    }
  }, [isVendorPackaging]);

  useEffect(() => {
    disableLastButton();
  }, [
    primaryDateForm,
    primaryForwarderList,
    shipmentSwitchTo,
    pickUpDateForm,
    pickUpForwarderList,
    pickUpSwitchTo,
    deliveryDateForm,
    deliveryForwarderList,
    deliverySwitchTo,
    selectedVendorType,
    pickUpValues,
    deliveryValues,
    originStatus,
    destinationStatus,
    primaryBookingCompleted,
    pickupBookingCompleted,
    deliveryBookingCompleted,
    bookingInfo?.directedBooking?.primary,
    bookingInfo?.directedBooking?.pickup,
    bookingInfo?.directedBooking?.delivery,
    scheduledPickupDate,
    scheduledPickupToDate,
    supplierTab,
    linerData,
    directShipmentBol,
    directShipmentEta,
    directShipmentEtd,
    directShipmentSwitchTo,
  ]);

  useEffect(() => {
    const updatedSelectedForwarder = [
      ...primaryForwarderList,
      ...pickUpForwarderList,
      ...deliveryForwarderList,
    ];
    const formatForwarderList = (data) => {
      const formattedForwarderList = data?.forwarderDetail?.map((obj) => ({
        ...obj,
        label: obj?.orgName,
        value: obj?.orgId,
      }));
      updatedSelectedForwarder.push(...formattedForwarderList);
    };

    if (primaryBookingData?.forwarderDetail?.length) {
      formatForwarderList(primaryBookingData);
    }
    if (pickUpBookingData?.forwarderDetail?.length) {
      formatForwarderList(pickUpBookingData);
    }
    if (deliveryBookingData?.forwarderDetail?.length) {
      formatForwarderList(deliveryBookingData);
    }

    setSelectedForwarders(updatedSelectedForwarder);
  }, [
    primaryForwarderList,
    pickUpForwarderList,
    deliveryForwarderList,
    primaryBookingData?.forwarderDetail,
    pickUpBookingData?.forwarderDetail,
    deliveryBookingData?.forwarderDetail,
  ]);

  const primaryDocArray = [];
  const pickUpDocArray = [];
  const deliveryDocArray = [];
  const formatDocumentMeta = (attachment, docArray) => {
    attachment?.forEach((attachmentItem) => {
      docArray.push({
        url: attachmentItem?.url,
        size: attachmentItem.fileSize,
        path: attachmentItem.filePath,
        originalName: attachmentItem.originalFileName,
        mimeType: attachmentItem.fileType,
        type: 'file',
      });
    });
  };
  formatDocumentMeta(primaryAttachment, primaryDocArray);
  formatDocumentMeta(pickUpAttachment, pickUpDocArray);
  formatDocumentMeta(deliveryAttachment, deliveryDocArray);

  const handleUpdateBooking = () => {
    if (
      relation === 'customBroker' &&
      contractList?.length === 0 &&
      isConsoliatedBooking
    ) {
      toast.error(
        t(
          'manageordersscreen.createbookingmenu.contractedbooking.noContractedBooking'
        )
      );
      return;
    }
    setDisableLastBtn(true);
    const { hazmat, UNCode } = prodPackDetails;
    const primaryForwardersAndGeoCodes = getForwardersAndGeoCodes({
      forwarderList: primaryForwarderList,
      origin: originValues,
      destination: destinationValues,
    });
    const pickUpForwardersAndGeoCodes = getForwardersAndGeoCodes({
      forwarderList: pickUpForwarderList,
      origin: pickUpValues,
      destination: '',
    });
    const deliveryForwardersAndGeoCodes = getForwardersAndGeoCodes({
      forwarderList: deliveryForwarderList,
      origin: '',
      destination: deliveryValues,
    });
    const inlandGeoCodes = getForwardersAndGeoCodes({
      forwarderList: [],
      origin: originValues,
      destination: destinationValues,
    });

    const pickUpAddress = getAddress({
      type: 'origin',
      originData: pickUpValues,
      destinationData: {},
    });
    const deliveryAddress = getAddress({
      type: 'destination',
      originData: {},
      destinationData: deliveryValues,
    });

    // const originAddress = getAddress({
    //   type: 'origin',
    //   originData: originValues,
    //   destinationData: {},
    // });

    // const destinationAddress = getAddress({
    //   type: 'destination',
    //   destinationData: destinationValues,
    //   originData: {},
    // });

    const originAddress = getNewAddress({
      type: 'origin',
      address: originValues?.originDoorAddress,
    });

    const destinationAddress = getNewAddress({
      type: 'destination',
      address: destinationValues?.destinationDoorAddress,
    });

    const getSelectedDocs = (vendorType) => {
      const selectedDocs = [];
      if (supplierUploadedDocs?.length) {
        supplierUploadedDocs?.forEach(
          ({ primarySelected, pickupSelected, deliverySelected, ...rest }) => {
            if (vendorType === 'primary' && primarySelected) {
              selectedDocs?.push({ ...rest });
            }
            if (vendorType === 'pickup' && pickupSelected) {
              selectedDocs?.push({ ...rest });
            }
            if (vendorType === 'delivery' && deliverySelected) {
              selectedDocs?.push({ ...rest });
            }
            return false;
          }
        );
      }
      return selectedDocs;
    };

    const pickUpPayload = {
      bookingType: 'Pickup',
      directBooking: profileType === 'buyer' ? pickUpSwitchTo : false,
      forwarders: pickUpForwardersAndGeoCodes?.forwarders,
      quotationExpiryDate: pickUpDateForm
        ? pickUpDateForm?.toISOString()
        : new Date(new Date().setDate(new Date().getDate() + 1)).toISOString(),
      scheduledPickupDate: scheduledPickupDate
        ? scheduledPickupDate?.toISOString()
        : '',
      scheduledPickupToDate: scheduledPickupToDate
        ? scheduledPickupToDate?.toISOString()
        : '',
      comment: commentPayload.pickupComment,
      address: [
        {
          ...pickUpAddress,
          geoCode: pickUpForwardersAndGeoCodes?.originGeoCode,
        },
      ],
    };

    const deliveryPayload = {
      bookingType: 'Delivery',
      directBooking: profileType === 'buyer' ? deliverySwitchTo : false,
      forwarders: deliveryForwardersAndGeoCodes?.forwarders,
      quotationExpiryDate: deliveryDateForm
        ? deliveryDateForm?.toISOString()
        : new Date(new Date().setDate(new Date().getDate() + 1)).toISOString(),
      scheduledPickupDate: scheduledPickupDate
        ? scheduledPickupDate?.toISOString()
        : '',
      scheduledPickupToDate: scheduledPickupToDate
        ? scheduledPickupToDate?.toISOString()
        : '',
      comment: commentPayload.deliverycomment,
      address: [
        {
          ...deliveryAddress,
          geoCode: deliveryForwardersAndGeoCodes?.destinationGeoCode,
        },
      ],
    };

    const primaryPayload = {
      bookingType: isConsoliatedBooking ? 'consolidated' : 'Primary',
      directBooking: profileType === 'buyer' ? shipmentSwitchTo : false,
      forwarders: selectedContract?._id
        ? [selectedContract?.forwarderDetails?.forwarder_orgId]
        : primaryForwardersAndGeoCodes?.forwarders,
      quotationExpiryDate: primaryDateForm
        ? primaryDateForm?.toISOString()
        : new Date(new Date().setDate(new Date().getDate() + 1)).toISOString(),
      scheduledPickupDate: scheduledPickupDate
        ? scheduledPickupDate?.toISOString()
        : '',
      scheduledPickupToDate: scheduledPickupToDate
        ? scheduledPickupToDate?.toISOString()
        : '',
      comment: commentPayload.primarycomment,
      address:
        bookingValue?.mode?.value === 'Inland'
          ? [
              {
                ...originAddress,
                geoCode: inlandGeoCodes?.originGeoCode,
              },
              {
                ...destinationAddress,
                geoCode: inlandGeoCodes?.destinationGeoCode,
              },
            ]
          : [
              {
                ...pickUpAddress,
                geoCode: pickUpForwardersAndGeoCodes?.originGeoCode,
              },
              {
                ...deliveryAddress,
                geoCode: deliveryForwardersAndGeoCodes?.destinationGeoCode,
              },
            ],
    };
    const bookHandle = {
      pickup: originStatus,
      delivery: destinationStatus,
    };

    let bookingData;
    if (selectedVendorType === 'primary') {
      if (originStatus && destinationStatus) {
        bookingData = [
          {
            ...primaryPayload,
            bookHandle,
            attachments: [...primaryDocArray, ...getSelectedDocs('primary')],
          },
        ];
      } else if (!originStatus && !destinationStatus) {
        bookingData = [
          {
            ...primaryPayload,
            bookHandle,
            address: [],
            attachments: [...primaryDocArray, ...getSelectedDocs('primary')],
          },
        ];
      } else if (originStatus) {
        bookingData = [
          {
            ...pickUpPayload,
            comment: commentPayload.primarycomment,
            directBooking: profileType === 'buyer' ? shipmentSwitchTo : false,
            bookingType: 'Primary',
            bookHandle,
            forwarders: primaryForwardersAndGeoCodes?.forwarders,
            attachments: [...primaryDocArray, ...getSelectedDocs('primary')],
          },
        ];
      } else if (destinationStatus) {
        bookingData = [
          {
            ...deliveryPayload,
            comment: commentPayload.primarycomment,
            directBooking: profileType === 'buyer' ? shipmentSwitchTo : false,
            bookingType: 'Primary',
            bookHandle,
            forwarders: primaryForwardersAndGeoCodes?.forwarders,
            attachments: [...primaryDocArray, ...getSelectedDocs('primary')],
          },
        ];
      }
    } else if (selectedVendorType === 'pickUp') {
      bookingData = [
        {
          ...pickUpPayload,
          attachments: [...pickUpDocArray, ...getSelectedDocs('pickup')],
        },
      ];
    } else if (selectedVendorType === 'delivery') {
      bookingData = [
        {
          ...deliveryPayload,
          attachments: [...deliveryDocArray, ...getSelectedDocs('delivery')],
        },
      ];
    }

    const returnAttach = (arr) => {
      const attachData = [];
      arr?.forEach((ele) => {
        attachData.push(...ele.attachments);
      });
      return attachData;
    };

    const shipmentPayload = {
      BLno: directShipmentBol,
      ETA: directShipmentEta,
      ETD: directShipmentEtd,
      Liner: linerData,
    };

    let input = {
      ...(isConsoliatedBooking
        ? { customIds }
        : { bookingId: bookingInfo?._id }),
      ...(isConsoliatedBooking && {
        scheduledPickupDate: scheduledPickupDate
          ? scheduledPickupDate?.toISOString()
          : '',
        scheduledPickupToDate: scheduledPickupToDate
          ? scheduledPickupToDate?.toISOString()
          : '',
      }),
      ...(directShipmentSwitchTo && {
        createShipment: shipmentPayload,
      }),
      ...(directShipmentSwitchTo &&
        consigneeId && {
          isDirectShipment: directShipmentSwitchTo,
        }),
      ...(isConsole && {
        packages: buildPackagesPayload(consolePackageData, tableData),
      }),
      originFacility: originValues?.origin,
      destinationFacility: destinationValues?.destination,
      cargoType: 'straight',
      mode: bookingValue?.mode?.value,
      shipmentType: bookingValue?.shipmentType?.value || 'Import',
      ...(bookingValue?.mode?.value !== 'Ocean' && {
        serviceLevel: bookingValue?.serviceLevel?.value || 'standard',
      }),
      hazmat,
      unCode: Array.isArray(UNCode) ? UNCode : [],
      profileType: giveProfile(relation),
      typeofMove: bookingValue?.typeOfMove?.value,
      ...(bookingValue?.mode?.value === 'Ocean' && {
        containerType: bookingValue?.containerType?.value,
        equipmentType: bookingValue?.equipmentType?.value,
        equipTypeQty: Number(bookingValue?.equipTypeQty),
      }),
      incoTerm: isConsoliatedBooking ? 'NA' : bookingValue?.incoTerm?.value,
      ...(bookingValue?.mode?.value === 'Inland' && {
        cargoLoad: bookingValue?.cargoLoad?.value,
        truckType: bookingValue?.truckType?.value,
        numberOfTrucks: Number(bookingValue?.numberOfTrucks),
        originLocationName: bookingValue?.originLocation?.value,
        destinationLocationName: bookingValue?.destinationLocation?.value,
      }),
      ...(selectedContract?._id && {
        contract: selectedContract,
      }),
      originGeoCode: primaryForwardersAndGeoCodes?.originGeoCode,
      ...(isConsole && {
        originPortCode: originValues?.originGeoCode[0]?.value,
      }),
      destinationGeoCode: primaryForwardersAndGeoCodes?.destinationGeoCode,
      ...(isConsole && {
        destinationPortCode: destinationValues?.destinationGeoCode[0]?.value,
      }),
      ...(isConsole && {
        airFreightType: bookingValue?.airFreightType?.label,
      }),
      bookings:
        isConsoliatedBooking && destinationStops?.length > 0
          ? bookingData.map((bd, idx) =>
              idx === 0 ? { ...bd, destinationStop: destinationStops } : bd
            )
          : bookingData,
      attachments: returnAttach(bookingData),
      entitiesInput: [
        {
          type: 'notify party',
          id: 0,
          name: confirmEntity.notificationDetail,
        },
        {
          type: 'consignee',
          id: 1,
          name: confirmEntity.consigneeDetail,
        },
      ],
      ...(!isConsoliatedBooking && {
        paymentMethod: paymentGateway,
      }),
    };
    setIsApiCallPending(true);

    if (consigneeId && !isConsole) {
      const packagesInput = packages?.map((pkg) => {
        const {
          name,
          quantity,
          length,
          width,
          height,
          grossWeight,
          measurementUnit,
          selectedProductIds,
        } = pkg;
        const lineItems = [];
        products?.forEach((prd) => {
          if (selectedProductIds?.includes(prd?.id)) {
            const {
              name: itemName,
              quantity: pQuantity,
              length: pLength,
              width: pWidth,
              height: pHeight,
              grossWeight: pGrossWeight,
              pricePerUnit: price,
              currency,
              measurementUnit: pMeasurementUnit,
            } = prd;
            const modifiedProducts = {
              itemName,
              price: Number(price),
              quantity: Number(pQuantity),
              dimensions: [
                {
                  length: Number(pLength),
                  height: Number(pHeight),
                  width: Number(pWidth),
                },
              ],
              measurementUnit: pMeasurementUnit,
              grossWeight: Number(pGrossWeight),
              currency,
            };
            lineItems.push(modifiedProducts);
          }
        });
        return {
          packageType: name,
          pkgGrossWt: grossWeight,
          pkgWtUnit: measurementUnit,
          pkgQty: Number(quantity),
          dimentions: {
            length: Number(length),
            width: Number(width),
            height: Number(height),
          },
          isVendor: name === 'Default Package',
          lineItems,
        };
      });

      const { kindOfGoods, cargoReadyDate, customClearance, HSCode, plant } =
        prodPackDetails;

      const inputForRFQ = {
        rfqType: 'export',
        consigneeId,
        cargoReadyDate,
        customClearance,
        hazmat,
        hsCode: HSCode,
        unCode: Array.isArray(UNCode) ? UNCode : [],
        kindOfGoods,
        totalWeight: bookingValue?.totalWeight?.toString(),
        weightUnit: bookingValue?.weightUnit?.value || 'Kgs',
        shipmentFrequency: bookingValue?.shipmentFrequency?.value,
        packages: packagesInput,
        ...(plant?._id && { buyerEntityId: [plant?._id] }),
      };
      input = { ...input, ...inputForRFQ };

      rfqBookingHandler({
        variables: {
          input,
        },
        onCompleted: (resp) => {
          toast.success(resp?.CreateNewBooking?.message);
          setIsApiCallPending(false);
          toggleRFQ();
          toggleViewDetailsModal();
          searchParams.set('triggerNotiCount', true);
          setSearchParams(searchParams);
        },
        onError: () => {
          setIsApiCallPending(false);
          setDisableLastBtn(false);
        },
      });
    }

    if (isConsoliatedBooking && !directShipmentSwitchTo && !isConsole) {
      consolidatedBookingHandler({
        variables: {
          input,
        },
        onCompleted: (resp) => {
          toast.success(resp?.ConsolidateBook?.message);
          setIsApiCallPending(false);
          refetchConsolidatedList();
          searchParams.set('triggerNotiCount', true);
          setSearchParams(searchParams);
        },
        onError: () => {
          setIsApiCallPending(false);
          setDisableLastBtn(false);
        },
      });
    }

    if (
      !consigneeId &&
      !isConsoliatedBooking &&
      !directShipmentSwitchTo &&
      !isConsole &&
      !bulkVitroRefIds?.length
    ) {
      if (!isBulk) {
        updateBookingHandler({
          variables: {
            input,
          },
          onCompleted: (resp) => {
            toast.success(resp?.UpdatingBooking?.message);
            refetch();
            setIsApiCallPending(false);
            searchParams.set('triggerNotiCount', true);
            setSearchParams(searchParams);
          },
          onError: () => {
            setIsApiCallPending(false);
          },
        });
      } else {
        updateBulkBookingHandler({
          variables: {
            input,
          },
          onCompleted: (resp) => {
            toast.success(resp?.BulkCompleteBooking?.message);
            refetch();
            setIsApiCallPending(false);
            searchParams.set('triggerNotiCount', true);
            if (searchParams.get('popover')) {
              searchParams.delete('popover');
            }
            setSearchParams(searchParams);
          },
          onError: () => {
            setIsApiCallPending(false);
          },
        });
      }
    }

    if (directShipmentSwitchTo && !consigneeId) {
      updateBookingWithoutForwarder({
        variables: {
          input,
        },
        onCompleted: (resp) => {
          toast.success(resp?.BulkUpdatingBookingWithoutForwarder?.message);
          refetch();
          setIsApiCallPending(false);
          searchParams.set('triggerNotiCount', true);
          setSearchParams(searchParams);
          if (bulkVitroRefIds?.length) {
            refetchConsolidatedList();
          }
        },
        onError: () => {
          setIsApiCallPending(false);
          setDisableLastBtn(false);
        },
      });
    }

    if (isConsole) {
      updateBookingConsole({
        variables: {
          input,
        },
        onCompleted: (resp) => {
          toast.success(resp?.connectCreateBooking?.message);
          refetchConsolidatedList();
          setIsApiCallPending(false);
        },
        onError: () => {
          setIsApiCallPending(false);
          setDisableLastBtn(false);
        },
      });
    }

    if (bulkVitroRefIds?.length && !directShipmentSwitchTo) {
      if (paymentGateway) {
        input.paymentMethod = paymentGateway;
      }

      if (input.destinationGeoCode.lat === 'NULL') {
        input.destinationGeoCode.lat = '';
      }
      if (input.originGeoCode.lat === 'NULL') {
        input.originGeoCode.lat = '';
      }
      if (input.attachments[0]?.type === null) {
        input.attachments = [];
      }
      createConsoleVitroBulkBooking({
        variables: {
          input,
        },
        onCompleted: (resp) => {
          toast.success(resp?.createBulkBooking?.message);
          // refetch(); uncomment once pickup & delivery booking is enabled
          refetchConsolidatedList();
          setIsApiCallPending(false);
        },
        onError: () => {
          setIsApiCallPending(false);
          setDisableLastBtn(false);
        },
      });
    }
  };

  let showSchedDateAtPrimary = false;
  let showSchedDateAtPickup = false;
  if (bookingValue?.typeOfMove?.value?.includes('port to')) {
    showSchedDateAtPrimary = true;
    showSchedDateAtPickup = false;
  } else if (bookingValue?.typeOfMove?.value === 'door to port') {
    if (originStatus && !destinationStatus) {
      showSchedDateAtPrimary = true;
      showSchedDateAtPickup = false;
    } else {
      showSchedDateAtPrimary = false;
      showSchedDateAtPickup = true;
    }
  } else if (bookingValue?.typeOfMove?.value === 'door to door') {
    if (originStatus) {
      showSchedDateAtPrimary = true;
      showSchedDateAtPickup = false;
    } else {
      showSchedDateAtPrimary = false;
      showSchedDateAtPickup = true;
    }
  }

  const permissionsToCheck = [
    ['Supplier Role', 'createCargoRequest'],
    ['Supplier Role', 'Milestone update'],
    ['Supplier Role', 'ChangeRequest'],
  ];

  const hasSupplierActPerm = permissionsToCheck.some((permission) =>
    checkPermission(giveProfile(relation), ...permission)
  );

  let submitBtnLabel;

  if (!selectedContract?._id && !isConsole) {
    if (
      profileType === 'buyer' &&
      ((shipmentSwitchTo && selectedVendorType === 'primary') ||
        (pickUpSwitchTo && selectedVendorType === 'pickUp') ||
        (deliverySwitchTo && selectedVendorType === 'delivery'))
    ) {
      submitBtnLabel = t(
        'manageordersscreen.createbookingmenu.addforwarder.pickupvendor.sendtosupplier'
      );
    } else if (directShipmentSwitchTo) {
      submitBtnLabel = t(
        'manageordersscreen.createbookingmenu.addforwarder.deliveryvendor.createshipment'
      );
    } else {
      submitBtnLabel = bookingInfo?.noRFQRequest
        ? t(
            'manageordersscreen.createbookingmenu.addforwarder.deliveryvendor.book'
          )
        : t(
            'manageordersscreen.createbookingmenu.addforwarder.deliveryvendor.requestquote'
          );
    }
  } else {
    submitBtnLabel = t(
      'manageordersscreen.createbookingmenu.addforwarder.deliveryvendor.createbooking'
    );
  }
  const getDocumentLabel = (mode) => {
    switch (mode) {
      case 'Air':
        return t(
          'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.enterbolair'
        );
      case 'Ocean':
        return t(
          'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.enterbolocean'
        );
      case 'Inland':
        return t(
          'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.enterbolland'
        );
      default:
        return 'Enter BOL/AWB/BL Number';
    }
  };

  return (
    <div>
      <div className="add-forwarder-wrapper d-flex justify-center">
        {bookingValue?.mode?.value !== 'Inland' &&
        !consigneeId &&
        !isConsole ? (
          // removed below condition as the left column was not rendered at supplier if only primary was directed to supplier
          //  && (isOriginDoor || isDestinationDoor)
          <div className="add-forwarder-left">
            <ul className="left-tab">
              {(profileType === 'supplier'
                ? bookingInfo?.directedBooking?.primary
                : true) && (
                <li>
                  <button
                    type="button"
                    disabled={disablePrimaryAtSupplier}
                    onClick={() => setSelectedVendorType('primary')}
                    className={getClassName('primary')}
                  >
                    {getIcons('primary')}
                    {t(
                      'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.title'
                    )}
                  </button>
                </li>
              )}

              {!channelPartnerData?.eventAction?.disableBookingEvent?.includes(
                'InlandBooking'
              ) &&
                !directShipmentSwitchTo &&
                !bulkVitroRefIds?.length && (
                  <>
                    {bookingValue?.typeOfMove?.value?.includes('door to') &&
                      (profileType === 'supplier'
                        ? bookingInfo?.directedBooking?.pickup
                        : true) && (
                        <li>
                          <button
                            type="button"
                            onClick={() => setSelectedVendorType('pickUp')}
                            disabled={isDisabled('Pickup')}
                            className={
                              isDisabled('Pickup') ? '' : getClassName('pickUp')
                            }
                          >
                            {!isDisabledIcon('Pickup')
                              ? getIcons('pickUp')
                              : isDisabledIcon('Pickup')}
                            {t(
                              'manageordersscreen.createbookingmenu.addforwarder.pickupvendor.title'
                            )}
                          </button>
                        </li>
                      )}
                    {bookingValue?.typeOfMove?.value?.includes('to door') &&
                      (profileType === 'supplier'
                        ? bookingInfo?.directedBooking?.delivery
                        : true) && (
                        <li>
                          <button
                            type="button"
                            onClick={() => setSelectedVendorType('delivery')}
                            className={
                              isDisabled('Delivery')
                                ? ''
                                : getClassName('delivery')
                            }
                            disabled={isDisabled('Delivery')}
                          >
                            {!isDisabledIcon('Delivery')
                              ? getIcons('delivery')
                              : isDisabledIcon('Delivery')}
                            {t(
                              'manageordersscreen.createbookingmenu.addforwarder.deliveryvendor.title'
                            )}
                          </button>
                        </li>
                      )}
                  </>
                )}
            </ul>
          </div>
        ) : null}

        <div className="add-forwarder-right">
          <PanelCard noShadow bodyClassName="pt-0">
            {selectedVendorType === 'primary' && (
              <>
                <div className="d-flex justify-between mb-0">
                  <h3 className="add-forwarder-title">
                    {t(
                      'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.title'
                    )}
                  </h3>
                  <div className="d-flex align-items-center">
                    {!isConsoliatedBooking &&
                      !selectedContract?._id &&
                      !buyerAction?.addPrimary &&
                      !buyerAction?.addDelivery &&
                      !buyerAction?.addPickup &&
                      !isConsole &&
                      toggleDirectShipmentPer && (
                        <>
                          <label className="pickup-label">
                            {t(
                              'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.directshipmentbtn'
                            )}
                          </label>
                          <CustomSwitch
                            className="pickup-switch"
                            onChange={(e) => {
                              setLinerData('');
                              setDirectShipmentBol('');
                              pickUpValues.origin = '';
                              deliveryValues.destination = '';
                              setDirectShipmentSwitchTo(e?.target?.checked);
                            }}
                            defaultChecked={
                              directShipmentSwitchTo || isVendorPackaging
                            }
                            disabled={buyerAction?.addPrimary}
                          />
                        </>
                      )}
                    {profileType === 'buyer' &&
                      !buyerAction?.addPrimary &&
                      !consigneeId &&
                      !hasSupplierActPerm &&
                      !selectedContract?._id && (
                        <>
                          <label className="pickup-label">
                            {t(
                              'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.shipmentsupplierbtn'
                            )}
                          </label>

                          <CustomSwitch
                            className="pickup-switch"
                            onChange={(e) => {
                              setShipmentSwitchTo(e?.target?.checked);
                            }}
                            defaultChecked={shipmentSwitchTo}
                            disabled={
                              buyerAction?.addPrimary ||
                              bookingInfo?.directedBooking?.primary
                            }
                          />
                        </>
                      )}

                    {((profileType === 'buyer' && !buyerAction?.addPrimary) ||
                      (profileType === 'supplier' &&
                        bookingInfo?.bookAction?.primary)) &&
                      false && (
                        <Button
                          icon={<UploadDocumentIcon />}
                          styles="icon"
                          className="ml-10"
                          onClick={toggleUploadDialog}
                          disabled={
                            profileType === 'buyer'
                              ? buyerAction?.addPrimary
                              : !bookingInfo?.bookAction?.primary
                          }
                        />
                      )}
                    <Dialog
                      isShowing={isActivateUploadDislog}
                      hide={toggleUploadDialog}
                      placement="middle"
                      maskZindex={1041}
                    >
                      <PanelCard
                        cardTitle={t(
                          'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.uploaddocuments'
                        )}
                        noShadow
                        border
                      >
                        <UploadDocument
                          selectedFiles={primarySelectedFiles}
                          Width="27.778vw"
                          onUpload={(data) => {
                            setPrimaryAttachment(data);
                            // setAddDocuments(true);
                          }}
                          attachment={primaryAttachment}
                          getLoaderStatus={getLoaderStatus}
                          setSelectedFiles={setPrimarySelectedFiles}
                          multiple
                          enableSelectFileFor="primary"
                          preUploadedFiles={supplierUploadedDocs}
                          onSelectUploadedDocs={updateSupplierUploadedDocs}
                        />
                        <PanelCardFooter align="right">
                          <Button
                            label={t(
                              'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.add'
                            )}
                            color="submit"
                            disabled={disableButton}
                            onClick={() => {
                              toggleUploadDialog();
                            }}
                          >
                            Add
                          </Button>
                        </PanelCardFooter>
                      </PanelCard>
                    </Dialog>
                  </div>
                </div>
                <p className="mode-of-shipment">
                  {t(
                    'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.origin'
                  )}{' '}
                  {originStatus
                    ? t(
                        'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.door'
                      )
                    : t(
                        'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.port'
                      )}{' '}
                  {t(
                    'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.to'
                  )}{' '}
                  {t(
                    'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.destination'
                  )}{' '}
                  {destinationStatus
                    ? t(
                        'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.door'
                      )
                    : t(
                        'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.port'
                      )}
                </p>
              </>
            )}
            {selectedVendorType === 'pickUp' && (
              <>
                <div className="d-flex justify-between mb-0">
                  <h3 className="add-forwarder-title">
                    {t(
                      'manageordersscreen.createbookingmenu.addforwarder.pickupvendor.title'
                    )}
                  </h3>
                  <div className="d-flex align-items-center">
                    {profileType === 'buyer' &&
                      !buyerAction?.addPickup &&
                      !hasSupplierActPerm && (
                        <>
                          <label className="pickup-label">
                            {t(
                              'manageordersscreen.createbookingmenu.addforwarder.pickupvendor.pickupdone'
                            )}
                          </label>

                          <CustomSwitch
                            className="pickup-switch"
                            onChange={(e) => {
                              setPickUpSwitchTo(e?.target?.checked);
                            }}
                            defaultChecked={pickUpSwitchTo}
                            disabled={
                              buyerAction?.addPickup ||
                              bookingInfo?.directedBooking?.pickup
                            }
                          />
                        </>
                      )}
                    {((profileType === 'buyer' && !buyerAction?.addPickup) ||
                      (profileType === 'supplier' &&
                        bookingInfo?.bookAction?.pickup)) &&
                      false && (
                        <Button
                          icon={<UploadDocumentIcon />}
                          styles="icon"
                          className="ml-10"
                          onClick={toggleUploadDialog}
                          disabled={
                            profileType === 'buyer'
                              ? buyerAction?.addPickup
                              : !bookingInfo?.bookAction?.pickup
                          }
                        />
                      )}
                    <Dialog
                      isShowing={isActivateUploadDislog}
                      hide={toggleUploadDialog}
                      placement="middle"
                      maskZindex={1041}
                    >
                      <PanelCard
                        cardTitle={t(
                          'manageordersscreen.createbookingmenu.addforwarder.pickupvendor.uploaddocuments'
                        )}
                        noShadow
                        border
                      >
                        <UploadDocument
                          selectedFiles={pickUpSelectedFiles}
                          Width="27.778vw"
                          onUpload={(data) => {
                            setPickUpAttachment(data);
                            // setAddDocuments(true);
                          }}
                          attachment={pickUpAttachment}
                          getLoaderStatus={getLoaderStatus}
                          setSelectedFiles={setPickUpSelectedFiles}
                          multiple
                          enableSelectFileFor="pickup"
                          preUploadedFiles={supplierUploadedDocs}
                          onSelectUploadedDocs={updateSupplierUploadedDocs}
                        />
                        <PanelCardFooter align="right">
                          <Button
                            label={t(
                              'manageordersscreen.createbookingmenu.addforwarder.pickupvendor.add'
                            )}
                            color="submit"
                            disabled={disableButton}
                            onClick={() => {
                              toggleUploadDialog();
                            }}
                          >
                            Add
                          </Button>
                        </PanelCardFooter>
                      </PanelCard>
                    </Dialog>
                  </div>
                </div>
                <p className="mode-of-shipment">
                  {t(
                    'manageordersscreen.createbookingmenu.addforwarder.pickupvendor.doortoport'
                  )}
                </p>
              </>
            )}
            {selectedVendorType === 'delivery' && (
              <>
                <div className="d-flex justify-between mb-0">
                  <h3 className="add-forwarder-title">
                    {t(
                      'manageordersscreen.createbookingmenu.addforwarder.deliveryvendor.title'
                    )}
                  </h3>
                  <div className="d-flex align-items-center">
                    {profileType === 'buyer' &&
                      !buyerAction?.addDelivery &&
                      !hasSupplierActPerm && (
                        <>
                          <label className="pickup-label">
                            {t(
                              'manageordersscreen.createbookingmenu.addforwarder.deliveryvendor.deliverysupplier'
                            )}
                          </label>

                          <CustomSwitch
                            className="pickup-switch"
                            onChange={(e) => {
                              setDeliverySwitchTo(e?.target?.checked);
                            }}
                            defaultChecked={deliverySwitchTo}
                            disabled={
                              buyerAction?.addDelivery ||
                              bookingInfo?.directedBooking?.delivery
                            }
                          />
                        </>
                      )}
                    {((profileType === 'buyer' && !buyerAction?.addDelivery) ||
                      (profileType === 'supplier' &&
                        bookingInfo?.bookAction?.delivery)) &&
                      false && (
                        <Button
                          icon={<UploadDocumentIcon />}
                          styles="icon"
                          className="ml-10"
                          onClick={toggleUploadDialog}
                          disabled={
                            profileType === 'buyer'
                              ? buyerAction?.addDelivery
                              : !bookingInfo?.bookAction?.delivery
                          }
                        />
                      )}
                    <Dialog
                      isShowing={isActivateUploadDislog}
                      hide={toggleUploadDialog}
                      placement="middle"
                      maskZindex={1041}
                    >
                      <PanelCard
                        cardTitle={t(
                          'manageordersscreen.createbookingmenu.addforwarder.deliveryvendor.uploaddocuments'
                        )}
                        noShadow
                        border
                      >
                        <UploadDocument
                          selectedFiles={deliverySelectedFiles}
                          Width="27.778vw"
                          onUpload={(data) => {
                            setDeliveryAttachment(data);
                            // setAddDocuments(true);
                          }}
                          attachment={deliveryAttachment}
                          getLoaderStatus={getLoaderStatus}
                          setSelectedFiles={setDeliverySelectedFiles}
                          multiple
                          enableSelectFileFor="delivery"
                          preUploadedFiles={supplierUploadedDocs}
                          onSelectUploadedDocs={updateSupplierUploadedDocs}
                        />
                        <PanelCardFooter align="right">
                          <Button
                            label={t(
                              'manageordersscreen.createbookingmenu.addforwarder.deliveryvendor.add'
                            )}
                            color="submit"
                            disabled={disableButton}
                            onClick={() => {
                              toggleUploadDialog();
                            }}
                          >
                            Add
                          </Button>
                        </PanelCardFooter>
                      </PanelCard>
                    </Dialog>
                  </div>
                </div>
                <p className="mode-of-shipment">
                  {t(
                    'manageordersscreen.createbookingmenu.addforwarder.deliveryvendor.description'
                  )}
                </p>
              </>
            )}
            <ShipmentProgress
              activeOriginDoor={originStatus}
              activeDestinationDoor={destinationStatus}
              enableDestinationDoor={handleDestinationStatus}
              enableOriginDoor={handleOriginStatus}
              disableOriginDoor={
                directShipmentSwitchTo ||
                consigneeId ||
                !isOriginDoor ||
                buyerAction?.addPrimary ||
                (profileType === 'buyer' &&
                  bookingInfo?.directedBooking?.primary) ||
                store
                  .getState()
                  .omniDetails?.channelPartnerData?.eventAction?.disableBookingEvent?.includes(
                    'InlandBooking'
                  ) ||
                (profileType === 'supplier' && pickupBookingCompleted) ||
                !!bulkVitroRefIds?.length ||
                bookingInfo?.supplierBookingPermission ||
                true // Temporarily disabling origin and destination door
              }
              disableDestinationDoor={
                directShipmentSwitchTo ||
                consigneeId ||
                !isDestinationDoor ||
                buyerAction?.addPrimary ||
                (profileType === 'buyer' &&
                  bookingInfo?.directedBooking?.primary) ||
                store
                  .getState()
                  .omniDetails?.channelPartnerData?.eventAction?.disableBookingEvent?.includes(
                    'InlandBooking'
                  ) ||
                (profileType === 'supplier' && deliveryBookingCompleted) ||
                !!bulkVitroRefIds?.length ||
                bookingInfo?.supplierBookingPermission ||
                true // Temporarily disabling origin and destination door
              }
              selectedVendorType={selectedVendorType}
              mode={bookingValue?.mode?.value}
              typeOfMove={bookingValue?.typeOfMove?.value}
              directShipmentSwitchTo={directShipmentSwitchTo}
              t={t}
              isConsole={isConsole}
            />

            {/* Select Forwarder dropdowns */}
            <div className="add-forwarder-container">
              {directShipmentSwitchTo && (
                <>
                  <div className="form-row">
                    <div className="icon">
                      <ShipmentIcon size="1.667vw" />
                    </div>
                    <div className="form">
                      <label className="label">
                        {t(
                          'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.selectliner'
                        )}
                        {/*   <span className="required">*</span> */}
                      </label>
                      <TextBox
                        onChange={(e) => setLinerData(e.target.value)}
                        placeholder={t(
                          'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.selectliner'
                        )}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="icon">
                      <CalenderIcon color="#395C85" size="1.667vw" />
                    </div>
                    <div className="form">
                      <label className="label">
                        {t(
                          'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.etd'
                        )}
                        {/*    <span className="required">*</span> */}
                      </label>
                      <DatepickerBox
                        required
                        selectedDate={directShipmentEtd}
                        setDate={(e) => {
                          setDirectShipmentEtd(e);
                        }}
                        showTimeInput={true}
                        dateFormat="dd/MM/yyyy h:mm aa"
                        placeholder={t(
                          'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.etd'
                        )}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="icon">
                      <CalenderIcon color="#395C85" size="1.667vw" />
                    </div>
                    <div className="form">
                      <label className="label">
                        {t(
                          'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.eta'
                        )}
                        {/*        <span className="required">*</span> */}
                      </label>
                      <DatepickerBox
                        required
                        selectedDate={directShipmentEta}
                        setDate={(e) => {
                          setDirectShipmentEta(e);
                        }}
                        showTimeInput={true}
                        dateFormat="dd/MM/yyyy h:mm aa"
                        placeholder={t(
                          'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.eta'
                        )}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="icon">
                      <BolAWBBLIcon size="1.667vw" />
                    </div>
                    <div className="form">
                      <label className="label">
                        {getDocumentLabel(bookingValue?.mode?.value)}
                        {/*         <span className="required">*</span> */}
                      </label>
                      <TextBox
                        type="text"
                        onChange={(e) => setDirectShipmentBol(e.target.value)}
                        placeholder={getDocumentLabel(
                          bookingValue?.mode?.value
                        )}
                      />
                    </div>
                  </div>
                  {(selectedVendorType === 'pickUp' ||
                    (originStatus &&
                      selectedVendorType === 'primary' &&
                      !shipmentSwitchTo)) &&
                    selectedVendorType !== 'delivery' &&
                    ((profileType === 'buyer' && !pickUpSwitchTo) ||
                      profileType === 'supplier') &&
                    bookingValue?.mode?.value !== 'Inland' && (
                      <div className="form-row">
                        <div className="icon">
                          <MapIcon width="24" color="#395C85" />
                        </div>
                        <div className="form">
                          <label className="label">
                            {t(
                              'manageordersscreen.createbookingmenu.addforwarder.pickupvendor.pickupaddress'
                            )}
                          </label>
                          {((profileType === 'buyer' &&
                            !buyerAction?.addPickup) ||
                            (profileType === 'supplier' &&
                              !pickupBookingCompleted &&
                              bookingInfo?.bookAction?.pickup)) && (
                            <AddAddress
                              disableDestination
                              Mode={bookingValue?.mode}
                              TypeOfMove={bookingValue?.typeOfMove}
                              origin={pickUpValues?.origin}
                              setOrigin={setPickUpVal('origin')}
                              originOptions={options?.pickUpOptions}
                              setOrginOptions={setOptionValues('pickUpOptions')}
                              originGeoCode={pickUpValues?.originGeoCode}
                              setOriginGeoCode={setPickUpVal('originGeoCode')}
                              setOriginDoorAddress={(e) => {
                                setPickUpVal('originDoorAddress')(e);
                                setPickUpVal('originCountry')(
                                  fetchAddress(
                                    'origin',
                                    'country',
                                    e,
                                    deliveryValues.destinationDoorAddress,
                                    pickUpValues.originDoorAddress
                                  )
                                );
                              }}
                              setOriginCountry={setPickUpVal('originCountry')}
                            />
                          )}
                          {((buyerAction?.addPickup &&
                            profileType === 'buyer') ||
                            (profileType === 'supplier' &&
                              pickupBookingCompleted)) && (
                            <TextBox value={pickUpValues?.origin} disabled />
                          )}
                        </div>
                      </div>
                    )}
                  {(selectedVendorType === 'delivery' ||
                    (destinationStatus &&
                      selectedVendorType === 'primary' &&
                      !shipmentSwitchTo)) &&
                    selectedVendorType !== 'pickUp' &&
                    !deliverySwitchTo &&
                    bookingValue?.mode?.value !== 'Inland' && (
                      <div className="form-row">
                        <div className="icon">
                          <MapIcon width="24" color="#395C85" />
                        </div>
                        <div className="form">
                          <label className="label">
                            {t(
                              'manageordersscreen.createbookingmenu.addforwarder.deliveryvendor.deliveryaddress'
                            )}
                          </label>
                          {((profileType === 'buyer' &&
                            !buyerAction?.addDelivery) ||
                            (profileType === 'supplier' &&
                              !deliveryBookingCompleted &&
                              bookingInfo?.bookAction?.delivery)) && (
                            <AddAddress
                              disableOrigin
                              Mode={bookingValue?.mode}
                              TypeOfMove={bookingValue?.typeOfMove}
                              destination={deliveryValues?.destination}
                              setDestination={setDeliveryVal('destination')}
                              destinationOptions={options?.deliveryOptions}
                              setDestinationOptions={setOptionValues(
                                'deliveryOptions'
                              )}
                              destinationGeoCode={
                                deliveryValues?.destinationGeoCode
                              }
                              setDestinationGeoCode={setDeliveryVal(
                                'destinationGeoCode'
                              )}
                              setDestinationDoorAddress={(e) => {
                                setDeliveryVal('destinationDoorAddress')(e);
                                setDeliveryVal('destinationCountry')(
                                  fetchAddress(
                                    'destination',
                                    'country',
                                    e,
                                    deliveryValues.destinationDoorAddress,
                                    pickUpValues.originDoorAddress
                                  )
                                );
                              }}
                              setDestinationCountry={setDeliveryVal(
                                'destinationCountry'
                              )}
                            />
                          )}
                          {((buyerAction?.addDelivery &&
                            profileType === 'buyer') ||
                            (profileType === 'supplier' &&
                              deliveryBookingCompleted)) && (
                            <TextBox
                              value={deliveryValues?.destination}
                              disabled
                            />
                          )}
                        </div>
                      </div>
                    )}

                  <div className="form-row">
                    <div className="icon">
                      <TrackingLinkIcon size="1.667vw" />
                    </div>
                    <div className="form">
                      <label className="label">
                        {t(
                          'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.trackinglink'
                        )}
                      </label>
                      <TextBox
                        placeholder={t(
                          'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.trackinglink'
                        )}
                      />
                    </div>
                  </div>
                </>
              )}
              {selectedVendorType === 'primary' &&
                ((profileType === 'buyer' &&
                  !shipmentSwitchTo &&
                  !directShipmentSwitchTo) ||
                  profileType === 'supplier' ||
                  profileType === 'customBroker') && (
                  <div className="form-row">
                    <div className="icon">
                      <ShipmentIcon size="1.667vw" />
                    </div>
                    <div className="form">
                      <label className="label">
                        {t(
                          'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.selectprimaryvendor'
                        )}
                        <span className="required">*</span>
                      </label>

                      {((profileType === 'buyer' && !buyerAction?.addPrimary) ||
                        (profileType === 'supplier' &&
                          bookingInfo?.bookAction?.primary &&
                          !primaryBookingCompleted) ||
                        profileType === 'customBroker' ||
                        isConsole) &&
                        !selectedContract?._id && (
                          <SelectForwarder
                            mode="multi-select"
                            setForwarder={setPrimaryForwarderList}
                            forwarder={primaryForwarderList}
                            selectedForwarders={selectedForwarders}
                            behaviour="select"
                          />
                        )}

                      {((buyerAction?.addPrimary && profileType === 'buyer') ||
                        (profileType === 'supplier' &&
                          primaryBookingCompleted)) &&
                        !selectedContract?._id &&
                        !isConsole && (
                          <TextBox
                            disabled
                            value={`${
                              primaryBookingData?.forwarderDetail?.[0].orgName
                            } ${
                              primaryBookingData?.forwarderDetail?.length > 1
                                ? '+'
                                : ''
                            }${
                              primaryBookingData?.forwarderDetail?.length > 1
                                ? primaryBookingData.forwarderDetail.length - 1
                                : ''
                            }`}
                          />
                        )}
                      {selectedContract?._id && (
                        <TextBox
                          disabled
                          value={`${selectedContract?.forwarderDetails?.forwarderName} `}
                        />
                      )}
                    </div>
                  </div>
                )}
              {selectedVendorType === 'pickUp' &&
                ((profileType === 'buyer' && !pickUpSwitchTo) ||
                  profileType === 'supplier') && (
                  <div className="form-row">
                    <div className="icon">
                      <ShipmentIcon size="1.667vw" />
                    </div>
                    <div className="form">
                      <label className="label">
                        {t(
                          'manageordersscreen.createbookingmenu.addforwarder.pickupvendor.selectpickupvendor'
                        )}
                        <span className="required">*</span>
                      </label>
                      {((profileType === 'buyer' && !buyerAction?.addPickup) ||
                        (profileType === 'supplier' &&
                          !pickupBookingCompleted &&
                          bookingInfo?.bookAction?.pickup)) && (
                        <SelectForwarder
                          mode="multi-select"
                          setForwarder={setPickUpForwarderList}
                          forwarder={pickUpForwarderList}
                          selectedForwarders={selectedForwarders}
                          behaviour="select"
                        />
                      )}
                      {((buyerAction?.addPickup && profileType === 'buyer') ||
                        (profileType === 'supplier' &&
                          pickupBookingCompleted)) && (
                        <TextBox
                          disabled
                          value={`${
                            pickUpBookingData?.forwarderDetail?.[0].orgName
                          } ${
                            pickUpBookingData?.forwarderDetail?.length > 1
                              ? '+'
                              : ''
                          }${
                            pickUpBookingData?.forwarderDetail?.length > 1
                              ? pickUpBookingData.forwarderDetail.length - 1
                              : ''
                          }`}
                        />
                      )}
                    </div>
                  </div>
                )}
              {selectedVendorType === 'delivery' &&
                ((profileType === 'buyer' && !deliverySwitchTo) ||
                  profileType === 'supplier') && (
                  <div className="form-row">
                    <div className="icon">
                      <ShipmentIcon size="1.667vw" />
                    </div>
                    <div className="form">
                      <label className="label">
                        {t(
                          'manageordersscreen.createbookingmenu.addforwarder.deliveryvendor.selectdeliveryvendor'
                        )}
                        <span className="required">*</span>
                      </label>
                      {((profileType === 'buyer' &&
                        !buyerAction?.addDelivery) ||
                        (profileType === 'supplier' &&
                          !deliveryBookingCompleted &&
                          bookingInfo?.bookAction?.delivery)) && (
                        <SelectForwarder
                          mode="multi-select"
                          setForwarder={setDeliveryForwarderList}
                          forwarder={deliveryForwarderList}
                          selectedForwarders={selectedForwarders}
                          behaviour="select"
                        />
                      )}
                      {((buyerAction?.addDelivery && profileType === 'buyer') ||
                        (profileType === 'supplier' &&
                          deliveryBookingCompleted)) && (
                        <TextBox
                          disabled
                          value={`${
                            deliveryBookingData?.forwarderDetail?.[0].orgName
                          } ${
                            deliveryBookingData?.forwarderDetail?.length > 1
                              ? '+'
                              : ''
                          }${
                            deliveryBookingData?.forwarderDetail?.length > 1
                              ? deliveryBookingData.forwarderDetail.length - 1
                              : ''
                          }`}
                        />
                      )}
                    </div>
                  </div>
                )}
              {/* Select Address */}
              {(selectedVendorType === 'pickUp' ||
                (originStatus &&
                  selectedVendorType === 'primary' &&
                  !shipmentSwitchTo &&
                  !directShipmentSwitchTo) ||
                (originStatus &&
                  selectedVendorType === 'primary' &&
                  isConsole)) &&
                selectedVendorType !== 'delivery' &&
                ((profileType === 'buyer' && !pickUpSwitchTo) ||
                  profileType === 'supplier') &&
                bookingValue?.mode?.value !== 'Inland' && (
                  <div className="form-row">
                    <div className="icon">
                      <MapIcon width="24" color="#395C85" />
                    </div>
                    <div className="form">
                      <label className="label">
                        {t(
                          'manageordersscreen.createbookingmenu.addforwarder.pickupvendor.pickupaddress'
                        )}
                        <span className="required">*</span>
                      </label>
                      {((profileType === 'buyer' && !buyerAction?.addPickup) ||
                        (profileType === 'supplier' &&
                          !pickupBookingCompleted &&
                          bookingInfo?.bookAction?.pickup &&
                          !bookingInfo?.supplierBookingPermission) ||
                        (profileType === 'supplier' && isConsole) ||
                        (profileType === 'supplier' &&
                          !buyerAction?.addPickup &&
                          bookingInfo?.supplierBookingPermission)) && (
                        <AddAddress
                          disableDestination
                          Mode={bookingValue?.mode}
                          TypeOfMove={bookingValue?.typeOfMove}
                          origin={pickUpValues?.origin}
                          setOrigin={setPickUpVal('origin')}
                          originOptions={options?.pickUpOptions}
                          setOrginOptions={setOptionValues('pickUpOptions')}
                          originGeoCode={pickUpValues?.originGeoCode}
                          setOriginGeoCode={setPickUpVal('originGeoCode')}
                          setOriginDoorAddress={(e) => {
                            setPickUpVal('originDoorAddress')(e);
                            setPickUpVal('originCountry')(
                              fetchAddress(
                                'origin',
                                'country',
                                e,
                                deliveryValues.destinationDoorAddress,
                                pickUpValues.originDoorAddress
                              )
                            );
                          }}
                          setOriginCountry={setPickUpVal('originCountry')}
                        />
                      )}
                      {((buyerAction?.addPickup && profileType === 'buyer') ||
                        (profileType === 'supplier' &&
                          pickupBookingCompleted)) && (
                        <TextBox value={pickUpValues?.origin} disabled />
                      )}
                    </div>
                  </div>
                )}
              {(selectedVendorType === 'delivery' ||
                (destinationStatus &&
                  selectedVendorType === 'primary' &&
                  !shipmentSwitchTo &&
                  !directShipmentSwitchTo) ||
                (destinationStatus &&
                  selectedVendorType === 'primary' &&
                  isConsole)) &&
                selectedVendorType !== 'pickUp' &&
                !deliverySwitchTo &&
                bookingValue?.mode?.value !== 'Inland' && (
                  <div className="form-row">
                    <div className="icon">
                      <MapIcon width="24" color="#395C85" />
                    </div>
                    <div className="form">
                      <label className="label">
                        {t(
                          'manageordersscreen.createbookingmenu.addforwarder.deliveryvendor.deliveryaddress'
                        )}
                        <span className="required">*</span>
                      </label>
                      {((profileType === 'buyer' &&
                        !buyerAction?.addDelivery) ||
                        (profileType === 'supplier' &&
                          !deliveryBookingCompleted &&
                          bookingInfo?.bookAction?.delivery &&
                          !bookingInfo?.supplierBookingPermission) ||
                        (profileType === 'supplier' && isConsole) ||
                        (profileType === 'supplier' &&
                          !buyerAction?.addDelivery &&
                          bookingInfo?.supplierBookingPermission)) && (
                        <AddAddress
                          disableOrigin
                          Mode={bookingValue?.mode}
                          TypeOfMove={bookingValue?.typeOfMove}
                          destination={deliveryValues?.destination}
                          setDestination={setDeliveryVal('destination')}
                          destinationOptions={options?.deliveryOptions}
                          setDestinationOptions={setOptionValues(
                            'deliveryOptions'
                          )}
                          destinationGeoCode={
                            deliveryValues?.destinationGeoCode
                          }
                          setDestinationGeoCode={setDeliveryVal(
                            'destinationGeoCode'
                          )}
                          setDestinationDoorAddress={(e) => {
                            setDeliveryVal('destinationDoorAddress')(e);
                            setDeliveryVal('destinationCountry')(
                              fetchAddress(
                                'destination',
                                'country',
                                e,
                                deliveryValues.destinationDoorAddress,
                                pickUpValues.originDoorAddress
                              )
                            );
                          }}
                          setDestinationCountry={setDeliveryVal(
                            'destinationCountry'
                          )}
                        />
                      )}
                      {((buyerAction?.addDelivery && profileType === 'buyer') ||
                        (profileType === 'supplier' &&
                          deliveryBookingCompleted)) && (
                        <TextBox value={deliveryValues?.destination} disabled />
                      )}
                    </div>
                  </div>
                )}
              {/* Quotation Date fields */}
              {selectedVendorType === 'primary' &&
                ((profileType === 'buyer' &&
                  !shipmentSwitchTo &&
                  !directShipmentSwitchTo) ||
                  profileType === 'supplier' ||
                  profileType === 'customBroker') && (
                  <div>
                    {/* hide primary quote date for primary */}
                    {!selectedContract?._id &&
                      !isConsole &&
                      !bookingInfo?.noRFQRequest && (
                        <VendorQuotationSection
                          profileType={profileType}
                          selectedVendorType={selectedVendorType}
                          quotationLabel={t(
                            'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.quotation'
                          )}
                          dateForm={primaryDateForm}
                          setDateForm={setPrimaryDateForm}
                          bookingData={primaryBookingData}
                          showDatePicker={
                            (profileType === 'buyer' &&
                              !buyerAction?.addPrimary) ||
                            (profileType === 'supplier' &&
                              !primaryBookingCompleted &&
                              bookingInfo?.bookAction?.primary)
                          }
                          showDate={
                            (buyerAction?.addPrimary &&
                              profileType === 'buyer') ||
                            (profileType === 'supplier' &&
                              primaryBookingCompleted)
                          }
                          placeholder={t(
                            'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.quotationplac'
                          )}
                        />
                      )}
                    {showSchedDateAtPrimary && (
                      <>
                        <VendorQuotationSection
                          quotationLabel={t(
                            'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.schedulepickupdatefrom'
                          )}
                          dateForm={scheduledPickupDate}
                          setDateForm={(e) => {
                            if (!e) {
                              setScheduledPickupDate(null);
                              return;
                            }
                            const newDate = new Date(e);
                            newDate.setHours(14, 0, 0, 0);

                            setScheduledPickupDate(
                              scheduledPickupDate ? e : newDate
                            );
                          }}
                          bookingData={primaryBookingData}
                          showDatePicker={
                            (profileType === 'buyer' &&
                              !buyerAction?.addPrimary) ||
                            (profileType === 'supplier' &&
                              !primaryBookingCompleted &&
                              bookingInfo?.bookAction?.primary)
                          }
                          showDate={
                            (buyerAction?.addPrimary &&
                              profileType === 'buyer') ||
                            (profileType === 'supplier' &&
                              primaryBookingCompleted)
                          }
                          isContracted={true}
                          showTimeInput={true}
                          dateFormat="dd/MM/yyyy h:mm aa"
                          placeholder={t(
                            'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.schedulepickupdatefromplac'
                          )}
                        />
                        <VendorQuotationSection
                          quotationLabel={t(
                            'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.schedulepickupdateto'
                          )}
                          dateForm={scheduledPickupToDate}
                          setDateForm={(e) => {
                            if (!e) {
                              setScheduledPickupToDate(null);
                              return;
                            }
                            const newDate = new Date(e);
                            newDate.setHours(20, 0, 0, 0);

                            setScheduledPickupToDate(
                              scheduledPickupToDate ? e : newDate
                            );
                          }}
                          bookingData={primaryBookingData}
                          showDatePicker={
                            (profileType === 'buyer' &&
                              !buyerAction?.addPrimary) ||
                            (profileType === 'supplier' &&
                              !primaryBookingCompleted &&
                              bookingInfo?.bookAction?.primary)
                          }
                          showDate={
                            (buyerAction?.addPrimary &&
                              profileType === 'buyer') ||
                            (profileType === 'supplier' &&
                              primaryBookingCompleted)
                          }
                          isContracted={true}
                          showTimeInput={true}
                          dateFormat="dd/MM/yyyy h:mm aa"
                          placeholder={t(
                            'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.schedulepickupdatetoplac'
                          )}
                        />
                      </>
                    )}
                  </div>
                )}
              {selectedVendorType === 'pickUp' &&
                ((profileType === 'buyer' && !pickUpSwitchTo) ||
                  profileType === 'supplier') && (
                  <div>
                    <VendorQuotationSection
                      profileType={profileType}
                      selectedVendorType={selectedVendorType}
                      quotationLabel={t(
                        'manageordersscreen.createbookingmenu.addforwarder.pickupvendor.pickupquotation'
                      )}
                      dateForm={pickUpDateForm}
                      setDateForm={setPickUpDateForm}
                      bookingData={pickUpBookingData}
                      showDatePicker={
                        (profileType === 'buyer' && !buyerAction?.addPickup) ||
                        (profileType === 'supplier' &&
                          !pickupBookingCompleted &&
                          bookingInfo?.bookAction?.pickup)
                      }
                      showDate={
                        (buyerAction?.addPickup && profileType === 'buyer') ||
                        (profileType === 'supplier' && pickupBookingCompleted)
                      }
                      placeholder={t(
                        'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.quotationplac'
                      )}
                    />
                    {showSchedDateAtPickup && (
                      <>
                        <VendorQuotationSection
                          quotationLabel={t(
                            'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.schedulepickupdatefrom'
                          )}
                          dateForm={scheduledPickupDate}
                          setDateForm={(e) => {
                            if (!e) {
                              setScheduledPickupDate(null);
                              return;
                            }
                            const newDate = new Date(e);
                            newDate.setHours(14, 0, 0, 0);

                            setScheduledPickupDate(
                              scheduledPickupDate ? e : newDate
                            );
                          }}
                          bookingData={pickUpBookingData}
                          showDatePicker={
                            (profileType === 'buyer' &&
                              !buyerAction?.addPrimary) ||
                            (profileType === 'supplier' &&
                              !pickupBookingCompleted &&
                              bookingInfo?.bookAction?.primary)
                          }
                          showDate={
                            (buyerAction?.addPickup &&
                              profileType === 'buyer') ||
                            (profileType === 'supplier' &&
                              pickupBookingCompleted)
                          }
                          isContracted={true}
                          showTimeInput={true}
                          dateFormat="dd/MM/yyyy h:mm aa"
                          placeholder={t(
                            'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.schedulepickupdatefromplac'
                          )}
                        />
                        <VendorQuotationSection
                          quotationLabel={t(
                            'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.schedulepickupdateto'
                          )}
                          dateForm={scheduledPickupToDate}
                          setDateForm={(e) => {
                            if (!e) {
                              setScheduledPickupToDate(null);
                              return;
                            }
                            const newDate = new Date(e);
                            newDate.setHours(20, 0, 0, 0);
                            setScheduledPickupToDate(
                              scheduledPickupToDate ? e : newDate
                            );
                          }}
                          bookingData={pickUpBookingData}
                          showDatePicker={
                            (profileType === 'buyer' &&
                              !buyerAction?.addPrimary) ||
                            (profileType === 'supplier' &&
                              !pickupBookingCompleted &&
                              bookingInfo?.bookAction?.primary)
                          }
                          showDate={
                            (buyerAction?.addPickup &&
                              profileType === 'buyer') ||
                            (profileType === 'supplier' &&
                              pickupBookingCompleted)
                          }
                          isContracted={true}
                          showTimeInput={true}
                          dateFormat="dd/MM/yyyy h:mm aa"
                          placeholder={t(
                            'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.schedulepickupdatetoplac'
                          )}
                        />
                      </>
                    )}
                  </div>
                )}
              {selectedVendorType === 'delivery' &&
                ((profileType === 'buyer' && !deliverySwitchTo) ||
                  profileType === 'supplier') && (
                  <div>
                    {false && (
                      <div className="form-row">
                        <div className="icon">
                          <CalenderIcon color="#395C85" size="1.667vw" />
                        </div>
                        <div className="form">
                          <label className="label">
                            {t(
                              'manageordersscreen.createbookingmenu.addforwarder.deliveryvendor.deliveryquotation'
                            )}
                            <span className="required">*</span>
                          </label>
                          {((profileType === 'buyer' &&
                            !buyerAction?.addDelivery) ||
                            (profileType === 'supplier' &&
                              !deliveryBookingCompleted &&
                              bookingInfo?.bookAction?.delivery)) && (
                            <DatepickerBox
                              required
                              selectedDate={deliveryDateForm}
                              setDate={(e) => {
                                setDeliveryDateForm(e);
                              }}
                            />
                          )}
                          {((buyerAction?.addDelivery &&
                            profileType === 'buyer') ||
                            (profileType === 'supplier' &&
                              deliveryBookingCompleted)) && (
                            <TextBox
                              value={getUserTimeZoneDateFormat(
                                deliveryBookingData?.quotationExpiryDate
                              )}
                              disabled
                            />
                          )}
                        </div>
                      </div>
                    )}
                    <VendorQuotationSection
                      profileType={profileType}
                      selectedVendorType={selectedVendorType}
                      quotationLabel={t(
                        'manageordersscreen.createbookingmenu.addforwarder.deliveryvendor.deliveryquotation'
                      )}
                      dateForm={deliveryDateForm}
                      setDateForm={setDeliveryDateForm}
                      bookingData={deliveryBookingData}
                      showDatePicker={
                        (profileType === 'buyer' &&
                          !buyerAction?.addDelivery) ||
                        (profileType === 'supplier' &&
                          !deliveryBookingCompleted &&
                          bookingInfo?.bookAction?.delivery)
                      }
                      showDate={
                        (buyerAction?.addDelivery && profileType === 'buyer') ||
                        (profileType === 'supplier' && deliveryBookingCompleted)
                      }
                      placeholder={t(
                        'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.quotationplac'
                      )}
                    />
                  </div>
                )}
              {!isConsoliatedBooking && (
                <div className="form-row">
                  <div className="icon">
                    <WalletIcon color="#395C85" size="1.667vw" />
                  </div>
                  <div className="form">
                    <label className="label">
                      {t(
                        'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.paymentMethod'
                      )}
                    </label>
                    <AdvanceSelectLabel
                      placeholder={t(
                        'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.paymentMethod'
                      )}
                      data={[
                        {
                          label: t(
                            'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.credit'
                          ),
                          value: 'Credit',
                        },
                        {
                          label: t(
                            'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.prepaid'
                          ),
                          value: 'Prepaid',
                        },
                      ]}
                      defaultValue={
                        paymentGateway
                          ? {
                              label: t(
                                `manageordersscreen.createbookingmenu.addforwarder.primaryvendor.${paymentGateway.toLowerCase()}`
                              ),
                              value: paymentGateway,
                            }
                          : ''
                      }
                      removeSelectedValue={() => setPaymentGateway('')}
                      onChange={(val) => {
                        const value = val?.target?.value || val?.value;
                        setPaymentGateway(value);
                      }}
                    />
                  </div>
                </div>
              )}
            </div>

            {((shipmentSwitchTo && selectedVendorType === 'primary') ||
              (pickUpSwitchTo && selectedVendorType === 'pickUp') ||
              (deliverySwitchTo && selectedVendorType === 'delivery')) &&
              profileType === 'buyer' && (
                <NoData
                  image={<IncidentsNoData size="250px" />}
                  message={t(
                    'manageordersscreen.createbookingmenu.addforwarder.primaryvendor.shipmentsupplier'
                  )}
                />
              )}
          </PanelCard>
        </div>
      </div>
      <div class="btn-activity-div">
        {!directShipmentSwitchTo && (
          <Button
            label={t('manageordersscreen.bookingdetailsbtn.actions&activities')}
            styles="primary outline"
            id="activities"
            className={`activity-btn ${eventValue ? 'active' : ''}`}
            onClick={togglePopover}
            icon={<PlusIcon color="#2179C4" width="0.903vw" height="0.903vw" />}
          />
        )}
        <AdvancePopover
          reference="activities"
          closeOnclick
          closePopover={handleClose}
          getEvent={eventValue}
          placement="top"
        >
          <div className="activity">
            <ul className="activity-list">
              <li>
                {matchedBooking?.notes?.[0]?.comment !== '' && (
                  <ActionButton
                    className="btn-activity"
                    type="button"
                    onClick={toggleCommentDialog}
                    disabled={matchedBooking?.notes?.[0]?.comment === ''}
                  >
                    <AddCommentIcon />
                    {commentLabel}
                  </ActionButton>
                )}
                <Dialog
                  isShowing={isActivateCommentDialog}
                  hide={toggleCommentDialog}
                  placement="middle"
                  maskZindex={1041}
                >
                  <PanelCard
                    cardTitle={t('manageordersscreen.Bookings.note')}
                    className="comment-width"
                  >
                    {matchedBooking ? (
                      <CommentSection
                        commentData={matchedBooking?.notes?.[0]}
                      />
                    ) : (
                      <CommentSection
                        showComment={false}
                        isEditor={true}
                        handleCommentSubmit={handleCommentSubmit}
                        selectedVendorType={selectedVendorType}
                        toggleCommentDialog={toggleCommentDialog}
                        commentPayload={commentPayload}
                      />
                    )}
                  </PanelCard>
                </Dialog>
              </li>
              <li name="name">
                <ActionButton
                  className="btn-activity"
                  type="button"
                  onClick={toggleUploadDialog}
                >
                  <UploadDocumentIcon color="#2179C4" />
                  {t('manageordersscreen.bookingdetailsbtn.uploaddoc')}
                </ActionButton>
              </li>
              {false && (
                <li name="name">
                  <ActionButton className="btn-activity" type="button">
                    <DownloadZipIcon />
                    {t('manageordersscreen.bookingdetailsbtn.downloadzip')}
                  </ActionButton>
                </li>
              )}
            </ul>
          </div>
        </AdvancePopover>
      </div>

      <div className="supplier-booking-button-area justify-between">
        <Button
          label={t(
            'manageordersscreen.createbookingmenu.addforwarder.deliveryvendor.back'
          )}
          styles="back"
          size="large"
          icon={<PrevIcon />}
          spacing="0.694vw"
          className="px-24"
          onClick={() => {
            setAddForworder(true);
            setSupplierTab('confirm entity');
          }}
        />
        <Button
          label={
            isApiCallPending
              ? t(
                  'manageordersscreen.createbookingmenu.addforwarder.deliveryvendor.wait'
                )
              : submitBtnLabel
          }
          styles="submit"
          disabled={disableLastBtn || isApiCallPending}
          onClick={handleUpdateBooking}
          size="large"
          spacing="0.694vw"
          className="px-24"
        />
      </div>
    </div>
  );
}

export default React.memo(AddForwarderTab);

const defaultFormProps = {
  pickUpDateForm: PropTypes.instanceOf(Date),
  setPickUpDateForm: PropTypes.func,
  deliveryDateForm: PropTypes.instanceOf(Date),
  setDeliveryDateForm: PropTypes.func,
  primaryDateForm: PropTypes.instanceOf(Date),
  setPrimaryDateForm: PropTypes.func,
};
const defaultHandlerProps = {
  handleOriginStatus: PropTypes.func,
  handleDestinationStatus: PropTypes.func,
  updateSupplierUploadedDocs: PropTypes.func,
  handleCommentSubmit: PropTypes.func,
};
const defaultSwitchProps = {
  pickUpSwitchTo: PropTypes.func,
  deliverySwitchTo: PropTypes.func,
  shipmentSwitchTo: PropTypes.func,
  directShipmentSwitchTo: PropTypes.func,
  setShipmentSwitchTo: PropTypes.func,
  setPickUpSwitchTo: PropTypes.func,
  setDeliverySwitchTo: PropTypes.func,
  setDirectShipmentSwitchTo: PropTypes.func,
};
const defaultForwarderProps = {
  primaryForwarderList: PropTypes.instanceOf(Array),
  pickUpForwarderList: PropTypes.instanceOf(Array),
  deliveryForwarderList: PropTypes.instanceOf(Array),
  setPrimaryForwarderList: PropTypes.func,
  setPickUpForwarderList: PropTypes.func,
  setDeliveryForwarderList: PropTypes.func,
};
const defaultMiscProps = {
  buyerAction: {
    addPrimary: PropTypes.func,
    addPickup: PropTypes.func,
    addDelivery: PropTypes.func,
  },
  selectedVendorType: PropTypes.string,
  options: {
    pickUpOptions: PropTypes.instanceOf(Array),
    deliveryOptions: PropTypes.instanceOf(Array),
  },
  commentLabel: PropTypes.string,
  supplierUploadedDocs: PropTypes.instanceOf(Array),
  confirmEntity: {
    notificationDetail: PropTypes.instanceOf(Object),
    consigneeDetail: PropTypes.instanceOf(Object),
  },
  commentPayload: {
    pickupComment: PropTypes.string,
    deliveryComment: PropTypes.string,
    primaryComment: PropTypes.string,
  },
  originStatus: PropTypes.string,
  destinationStatus: PropTypes.string,
  originValues: {
    origin: PropTypes.string,
  },
  destinationValues: PropTypes.shape({
    destination: PropTypes.string,
  }),
  isOriginDoor: PropTypes.bool,
  isDestinationDoor: PropTypes.bool,
  disablePrimaryAtSupplier: PropTypes.bool,
  isActivateUploadDislog: PropTypes.bool,
  toggleUploadDialog: PropTypes.func,
  update: PropTypes.func,
  isBulk: PropTypes.bool,
  paymentGateway: PropTypes.string,
  setPaymentGateway: PropTypes.func,
};
const defaultUIProps = {
  isDisabled: PropTypes.bool,
  getClassName: PropTypes.func,
  isDisabledIcon: PropTypes.bool,
  getIcons: PropTypes.func,
  setSelectedVendorType: PropTypes.func,
};
const defaultShipmentProps = {
  linerData: PropTypes.string,
  setLinerData: PropTypes.func,
};
const defaultBookingProps = {
  bookingInfo: PropTypes.instanceOf(Object),
  bookingValue: PropTypes.instanceOf(Object),
  bookingList: PropTypes.array,
  matchedBooking: PropTypes.bool,
  deliveryBookingData: PropTypes.instanceOf(Object),
  deliveryBookingCompleted: PropTypes.bool,
  pickUpBookingData: PropTypes.instanceOf(Object),
  pickupBookingCompleted: PropTypes.bool,
  primaryBookingData: PropTypes.instanceOf(Object),
  primaryBookingCompleted: PropTypes.bool,
  deliveryValues: PropTypes.instanceOf(Object),
  pickUpValues: PropTypes.instanceOf(Object),
  prodPackDetails: PropTypes.instanceOf(Object),
  products: PropTypes.instanceOf(Array),
  packages: PropTypes.instanceOf(Array),
};

AddForwarderTab.propTypes = {
  formProps: PropTypes.instanceOf(defaultFormProps),
  bookingProps: PropTypes.instanceOf(defaultBookingProps),
  switchProps: PropTypes.instanceOf(defaultSwitchProps),
  forwarderProps: PropTypes.instanceOf(defaultForwarderProps),
  handlerProps: PropTypes.instanceOf(defaultHandlerProps),
  miscProps: PropTypes.instanceOf(defaultMiscProps),
  uiProps: PropTypes.instanceOf(defaultUIProps),
  shipmentProps: PropTypes.instanceOf(defaultShipmentProps),
  refetch: PropTypes.func,
  consigneeId: PropTypes.number,
  toggleRFQ: PropTypes.func,
  selectedContract: PropTypes.instanceOf(Object),
  isConsoliatedBooking: PropTypes.bool,
  customIds: PropTypes.instanceOf(Array),
  refetchConsolidatedList: PropTypes.func,
  toggleViewDetailsModal: PropTypes.func,
  contractList: PropTypes.instanceOf(Array),
  isVendorPackaging: PropTypes.bool,
  isConsole: PropTypes.bool,
  consolePackageData: PropTypes.instanceOf(Array),
  tableData: PropTypes.instanceOf(Array),
  bulkVitroRefIds: PropTypes.instanceOf(Array),
};
AddForwarderTab.defaultProps = {
  formProps: {},
  bookingProps: {},
  switchProps: {},
  forwarderProps: {},
  handlerProps: {
    handleOriginStatus: () => {},
    handleDestinationStatus: () => {},
    updateSupplierUploadedDocs: () => {},
    handleCommentSubmit: () => {},
  },
  miscProps: {},
  uiProps: {},
  shipmentProps: {},
  refetch: () => {},
  consigneeId: null,
  toggleRFQ: () => {},
  selectedContract: {},
  isConsoliatedBooking: false,
  customIds: [],
  refetchConsolidatedList: () => {},
  toggleViewDetailsModal: () => {},
  contractList: [],
  isVendorPackaging: false,
  isConsole: false,
  consolePackageData: [],
  tableData: [],
  bulkVitroRefIds: [],
};
